import React from 'react';
import { Link } from 'react-router-dom';

import Banner from '../../../src/images/banner/Freeconsult.svg';

const BannerConsult = (props) => {
    return (
        <div id="fp-animated" className="banner">
            <Link
                to="/online-consult"
                className={`friends-phone-btn ${
                    props.type === 'bts' ? 'banner__consult__bts' : ''
                }`}>
                <img src={Banner} alt="Banner consult FFB" />
            </Link>
        </div>
    );
};

export default BannerConsult;



// WEBPACK FOOTER //
// ./src/components/Pages/BannerConsult.jsx